import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Base from "./UI/Base";
var ErrorMessage = function ErrorMessage(_ref) {
  var message = _ref.message,
    additionalMessage = _ref.additionalMessage,
    type = _ref.type;
  var messages = Array.isArray(message) ? message : [message];
  var additionalMessages = Array.isArray(additionalMessage) ? additionalMessage : [additionalMessage];
  return /*#__PURE__*/React.createElement(Base, {
    type: type
  }, messages.map(function (messageItem, index) {
    return (
      /*#__PURE__*/
      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement("div", {
        key: index
      }, messageItem)
    );
  }), additionalMessages.length > 0 && /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("hr", null), additionalMessages.map(function (additionalMessageItem, index) {
    return (
      /*#__PURE__*/
      /* eslint-disable-next-line react/no-array-index-key */
      React.createElement("div", {
        key: index
      }, additionalMessageItem)
    );
  })));
};
var messageTypes = [PropTypes.string, PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.arrayOf(PropTypes.string)];
ErrorMessage.propTypes = {
  message: PropTypes.oneOfType(messageTypes).isRequired,
  additionalMessage: PropTypes.oneOfType(messageTypes),
  type: PropTypes.string.isRequired
};
ErrorMessage.defaultProps = {
  additionalMessage: []
};
export default ErrorMessage;